import type { ReactNode } from 'react';
import { useAbonnement } from '../hooks/useAbonnement.tsx';
import { moduleAutorise } from '../config/permissions.ts';
import { MODULE_LIBELLES, PACK_LIBELLES, packPourModule } from '../../../shared/business-logic/abonnement.ts';
import type { ModuleAbonnement } from '../../../shared/business-logic/abonnement.ts';

/** Remplace l'écran d'un module non inclus dans l'abonnement. Les saisies déjà faites ne sont jamais effacées. */
export default function Verrou({ module, onAbonnement }: { module: ModuleAbonnement; onAbonnement: () => void }) {
  return (
    <div className="carte" role="status">
      <h2>🔒 {MODULE_LIBELLES[module]}</h2>
      <p>Ce module n'est pas inclus dans votre abonnement actuel. Il est débloqué par le <b>{PACK_LIBELLES[packPourModule(module)]}</b> ou par l'option <b>Tout Activer</b>.</p>
      <p className="note">Vos données déjà saisies sont conservées et synchronisées normalement.</p>
      <button onClick={onAbonnement}>Voir les abonnements</button>
    </div>
  );
}

/** Affiche `children` si le module est accessible, sinon l'écran de verrouillage. */
export function PorteModule({ module, onAbonnement, children }: { module: ModuleAbonnement; onAbonnement: () => void; children: ReactNode }) {
  const { acces } = useAbonnement();
  // Compte d'essai « pre_rma_essai » : seuls CONSULTATION et CPN sont ouverts.
  const essai = localStorage.getItem('prerma_csb_id') === 'e55a1000-0000-4000-8000-000000000001';
  if (essai && module !== 'CONSULTATION' && module !== 'CPN') {
    return <div className="carte" role="alert"><h2>🔒 Module réservé</h2><p>🔒 Ce module est réservé aux centres de santé officiels. Demandez votre accès à l'Administrateur du projet.</p></div>;
  }
  if (!moduleAutorise(module)) return <VerrouAdmin module={module} />;
  return acces.modules[module] ? <>{children}</> : <Verrou module={module} onAbonnement={onAbonnement} />;
}

/** Module verrouillé par l'administrateur pour ce compte (Stock / Agent). */
export function VerrouAdmin({ module }: { module: ModuleAbonnement }) {
  return (
    <div className="carte" role="status">
      <h2>🔒 {MODULE_LIBELLES[module]}</h2>
      <p>Ce module est verrouillé pour votre compte. Contactez l'administrateur pour le débloquer.</p>
    </div>
  );
}
